import React from 'react';
import { Link } from 'react-router-dom';
import '../App.css';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="global-footer">
      <div className="footer-container">
        <div className="footer-section">
          <h4>Chaptery</h4>
          <p>A novel approach to organization.</p>
          <p className="operator-info">Operated by CadeKami Software Solutions, LLC</p>
        </div>
        
        <div className="footer-section">
          <h4>Product</h4>
          <ul className="footer-links">
            <li><Link to="/features">Features</Link></li>
            <li><Link to="/compare">Compare</Link></li>
            <li><Link to="/fantasy-writing-software">Fantasy Writing</Link></li>
            <li><Link to="/pricing">Pricing</Link></li>
          </ul>
        </div>

        <div className="footer-section">
          <h4>Legal</h4>
          <ul className="footer-links">
            <li><Link to="/tos">Terms of Service</Link></li>
            <li><Link to="/privacy">Privacy Policy</Link></li>
          </ul>
        </div>
        
        <div className="footer-section">
          <h4>Support</h4>
          <ul className="footer-links">
            <li><Link to="/help">Help &amp; Refunds</Link></li>
            <li><Link to="/checklist">Chaptery Checklist</Link></li>
            <li><a href="mailto:support@trychaptery.com">support@trychaptery.com</a></li>
          </ul>
        </div>
      </div>
      <div className="footer-bottom">
        <p>&copy; {currentYear} <Link to="https://cadekami.com">CadeKami Software Solutions, LLC</Link>. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
